import React, { useEffect, useState } from "react";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import { route } from "./../../../router/route";
import moment from "moment";
import { errorHandler } from "../../../util/errorHandler";
import RedBtn from "../../../component/atoms/button/redBtn";
import { toast } from "react-toastify";
import PopupOverLay from "../../../component/templates/PopupOverlay";
import Popup from "../../../component/molecules/popup";
import PretendardText from "../../../component/atoms/text/pretendardText";
import SubSideBar from "../../../component/organisms/subSideBar";
import SubSideBarItem from "../../../component/molecules/subSideBarItem";
import { useNavigate } from "react-router-dom";
import scrollToTop from "../../../util/scrollToTop";
import DividedBtn from "../../../component/atoms/button/dividedBtn";
import BasicBtn from "./../../../component/atoms/button/basicBtn";
import TextFormEditor from "../../../component/atoms/input/textFormEditor";
import { useRecoilState } from "recoil";
import {
  productIsUploadState,
  productManagementState,
} from "../../../store/productState";
import ProductApi from "../../../api/product.api";
import { toastMsg } from "../../../util/toastMsg";
import Modal from "../../../component/templates/Modal";

// TODO:
// - 추후 미리보기 페이지 구현 필요 (프리뷰 페이지 별도로 만들어야 할듯)

const ShoppingProductCreateDetail = () => {
  const navigate = useNavigate();

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    // 편집 권한 체크
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (!writeMenu?.includes(route.shopping_product)) {
      navigate(-1);
      toast(
        <>
          편집 권한이 없습니다.
          <br />
          최고관리자에게 문의하세요.
        </>
      );
      return;
    }

    getStorageList();

    // url 직접 입력으로 들어온 경우 기본 내용 설정 페이지로 이동
    if (productManagementValue.merchMainCategoryId === 0) {
      navigate(route.shopping_product_create_basic);
    }

    // 임시저장에서 불러온 경우 상품 업로드 상태 변경
    if (!productManagementValue.id) {
      setProductIsUpload(true);
    } else {
      setProductIsUpload(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 새로고침 이벤트 관련 ---------- //
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = "";
    };

    // 새로고침 및 페이지 떠남 이벤트 감지
    window.addEventListener("beforeunload", handleBeforeUnload);

    // 컴포넌트가 언마운트될 때 이벤트 리스너 제거
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  // ---------- 페이지 타이틀 관련 ---------- //
  const pageTitleList = [
    "01. 기본 내용 설정",
    "02. 상세 내용 설정",
    "03. 목차/커리큘럼 설정",
    "04. 썸네일 및 배너 설정",
    "05. 기타 설정",
  ];

  // ---------- 상품 업로드 상태 관련 ---------- //
  const [productIsUpload, setProductIsUpload] =
    useRecoilState(productIsUploadState);

  // ---------- 상품 추가 입력값 관련 ---------- //
  const [productManagementValue, setProductManagementValue] = useRecoilState(
    productManagementState
  );

  // ---------- 전체 영역 팝업 상태 관련 ---------- //
  const [popupOpen, setPopupOpen] = useState({
    temporary: false, // 임시저장
  });

  // ---------- 텍스트 에디터 관련 ---------- //
  const [isLoading, setIsLoading] = useState(false);

  // ---------- 임시저장 관련 ---------- //
  const [storageList, setStorageList] = useState([]);
  const [storageListCount, setStorageListCount] = useState(0);
  const [storageData, setStorageData] = useState({});

  const getStorageList = async () => {
    try {
      const data = {
        page: 1,
        size: 0,
        saveStatus: "N",
      };
      const response = await ProductApi.getListProduct(data);
      setStorageList(response.data.data.content);
      setStorageListCount(response.data.data.totalCount);
    } catch (error) {
      errorHandler(error);
    }
  };

  // 임시저장 데이터 삭제 관련
  const [deleteStorageItemModalOpen, setDeleteStorageItemModalOpen] =
    useState(false);
  const [deleteStorageItemId, setDeleteStorageItemId] = useState(0);

  const handleDeleteStorageItem = async () => {
    try {
      await ProductApi.deleteProduct(deleteStorageItemId);
      toast(toastMsg.delete);
      setDeleteStorageItemModalOpen(false);
      getStorageList();
    } catch (error) {
      errorHandler(error);
    }
  };

  // 데이터 불러오기
  const handleLoadStorageItem = async (id) => {
    try {
      const response = (await ProductApi.getByIdProduct(id)).data.data.content;
      setStorageData(response);

      setProductManagementValue({
        ...response,
        merchMainCategoryId: response?.merchMainCategory?.id || 0,
        merchSubCategoryId: response?.merchSubCategory?.id || 0,
        title: response.title || "",
        writer: response.writer || "",
        price: response.price || 0,
        isPreviewEnabled: response.isPreviewEnabled || false,
        isFreeTrial: response.isFreeTrial || false,
        isComingSoon: response.isComingSoon || false,
        isMembershipOnly: response.isMembershipOnly || false,
        intro: response.intro || "",
        content: response.content || "",
        thumbnailOriginFileName: response.thumbnailOriginFileName || "",
        thumbnailServerFileName: response.thumbnailServerFileName || "",
        bannerOriginFileName: response.bannerOriginFileName || "",
        bannerServerFileName: response.bannerServerFileName || "",
        relatedMerchUse: response.relatedMerchUse || false,
        openAlarmUse: response.openAlarmUse || false,
        merchType: response.merchType || "SHOP",
        merchContentType: response.merchContentType || "BOOK",
      });
      setProductIsUpload(false);
      setPopupOpen((prevPopup) => ({
        ...prevPopup,
        temporary: false,
      }));

      navigate(route.shopping_product_create_basic);
      toast("임시저장 데이터를 불러왔습니다.");
      scrollToTop();
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 다음 단계로 이동 ---------- //
  const handleNextStep = async () => {
    try {
      if (
        productManagementValue.intro === "" ||
        productManagementValue.intro === "<p><br></p>"
      ) {
        toast("상세 내용을 입력해주세요.");
        return;
      }
      if (productManagementValue.intro.length < 12) {
        toast("상세 내용이 너무 짧습니다.");
        return;
      } else if (
        (productManagementValue.merchMainCategoryId === 1 &&
          productManagementValue.content === "") ||
        (productManagementValue.merchMainCategoryId === 1 &&
          productManagementValue.content === "<p><br></p>")
      ) {
        toast("안내 내용을 입력해주세요.");
        return;
      } else if (
        productManagementValue.merchMainCategoryId === 1 &&
        productManagementValue.content.length < 12
      ) {
        toast("안내 내용이 너무 짧습니다.");
        return;
      } else if (
        (productManagementValue.merchMainCategoryId !== 1 &&
          productManagementValue.content === "") ||
        (productManagementValue.merchMainCategoryId !== 1 &&
          productManagementValue.content === "<p><br></p>")
      ) {
        toast("크리에이터 설명을 입력해주세요.");
        return;
      } else if (
        productManagementValue.merchMainCategoryId !== 1 &&
        productManagementValue.content.length < 12
      ) {
        toast("크리에이터 설명이 너무 짧습니다.");
        return;
      }

      if (
        !productManagementValue.id &&
        productManagementValue.merchMainCategoryId !== 0 &&
        productIsUpload
      ) {
        const response = await ProductApi.createProduct(productManagementValue);
        setProductManagementValue((prevInfo) => ({
          ...prevInfo,
          id: response.data.data.id,
        }));
        setProductIsUpload(false);
        navigate(route.shopping_product_create_chapter);
        scrollToTop();
      } else {
        const data = {
          title: productManagementValue.title,
          writer: productManagementValue.writer,
          price: productManagementValue.price,
          isPreviewEnabled: productManagementValue.isPreviewEnabled,
          isFreeTrial: productManagementValue.isFreeTrial,
          isComingSoon: productManagementValue.isComingSoon,
          isMembershipOnly: productManagementValue.isMembershipOnly,
          intro: productManagementValue.intro,
          content: productManagementValue.content,
          thumbnailOriginFileName:
            productManagementValue.thumbnailOriginFileName,
          thumbnailServerFileName:
            productManagementValue.thumbnailServerFileName,
          bannerOriginFileName: productManagementValue.bannerOriginFileName,
          bannerServerFileName: productManagementValue.bannerServerFileName,
          relatedMerchUse: productManagementValue.relatedMerchUse,
          openAlarmUse: productManagementValue.openAlarmUse,
          merchType: "SHOP",
          merchContentType: productManagementValue?.merchContentType,
          merchMainCategoryId: productManagementValue?.merchMainCategory?.id,
          merchSubCategoryId: productManagementValue?.merchSubCategory?.id,
        };

        await ProductApi.updateProduct(productManagementValue.id, data);

        navigate(route.shopping_product_create_chapter);
        scrollToTop();
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 카테고리 영역 */}
        <SubSideBar title="상품 추가">
          {pageTitleList.map((item, index) => {
            return (
              <React.Fragment key={index}>
                <SubSideBarItem
                  style={{
                    cursor: "default",
                  }}
                  selected={item === pageTitleList[1]}
                >
                  {item}
                </SubSideBarItem>
              </React.Fragment>
            );
          })}
        </SubSideBar>

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>{pageTitleList[1]}</TableTitle>

          <PretendardText
            style={{
              fontSize: "14px",
              fontWeight: "600",
              lineHeight: "22.75px",
              color: "#aaa",
              marginBottom: "20px",
            }}
          >
            소개
          </PretendardText>
          <TextFormEditor
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            placeholder={
              "상세 내용을 입력해주세요 (소개, 상세페이지 이미지 등)"
            }
            value={productManagementValue.intro}
            onChange={(contents) => {
              setProductManagementValue((prevInfo) => ({
                ...prevInfo,
                intro: contents,
              }));
            }}
            editorHeight={600}
            style={{
              width: "100%",
              marginBottom: "40px",
            }}
          />
          <PretendardText
            style={{
              fontSize: "14px",
              fontWeight: "600",
              lineHeight: "22.75px",
              color: "#aaa",
              marginBottom: "20px",
            }}
          >
            {productManagementValue.merchMainCategoryId === 1
              ? "안내"
              : "크리에이터"}
          </PretendardText>
          <TextFormEditor
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            placeholder={
              productManagementValue.merchMainCategoryId === 1
                ? "안내사항을 입력해주세요 (주의사항, 구매 방법, 인삿말, Q&A 등)"
                : "크리에이터 설명을 입력해주세요"
            }
            value={productManagementValue.content}
            onChange={(contents) => {
              setProductManagementValue((prevInfo) => ({
                ...prevInfo,
                content: contents,
              }));
            }}
            editorHeight={353}
            style={{
              width: "100%",
            }}
          />
          <div
            style={{
              width: "100%",
              height: 79,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              gap: 12,
            }}
          >
            <BasicBtn
              isTransparent={true}
              onClick={() => {
                navigate(route.shopping_product_create_basic);
                scrollToTop();
              }}
            >
              이전으로
            </BasicBtn>
            {/* <BasicBtn isBlue={true} onClick={() => {}}>
              미리보기
            </BasicBtn> */}
            <DividedBtn
              onClick={() => {
                setPopupOpen((prevPopup) => ({
                  ...prevPopup,
                  temporary: true,
                }));
              }}
              text1="임시저장"
              text2={storageListCount}
              textHandler={() => {
                setPopupOpen((prevPopup) => ({
                  ...prevPopup,
                  temporary: true,
                }));
              }}
            />
            <BasicBtn onClick={handleNextStep}>다음으로</BasicBtn>
          </div>
        </DetailPageLayout>
      </MainLayout>

      {/* 임시저장 팝업 */}
      {popupOpen.temporary && (
        <PopupOverLay
          isOpen={true}
          onClick={() => {
            setPopupOpen((prevPopup) => ({
              ...prevPopup,
              temporary: false,
            }));
          }}
        >
          <Popup
            headerTitle="임시저장 글"
            noFooter={true}
            onClick={() => {
              setPopupOpen((prevPopup) => ({
                ...prevPopup,
                temporary: false,
              }));
            }}
          >
            <div
              className="custom-scrollbar"
              style={{
                width: "100%",
                maxHeight: 284,
                overflowY: "auto",
                display: "flex",
                flexDirection: "column",
                marginTop: 16,
                padding: "0px 30px",
              }}
            >
              {storageList.map((item, index) => {
                return (
                  <div
                    key={index}
                    style={{
                      width: "100%",
                      height: 71,
                      padding: "15px 0px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      borderBottom:
                        "0.5px solid var(--outline1, rgba(255, 255, 255, 0.12))",
                    }}
                  >
                    <div
                      style={{
                        width: 515,
                        display: "flex",
                        flexDirection: "column",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        handleLoadStorageItem(item.id);
                      }}
                    >
                      <PretendardText
                        className="truncate"
                        style={{
                          width: "100%",
                          fontWeight: 500,
                          fontSize: 14,
                          lineHeight: "22px",
                          letterSpacing: "-0.3%",
                          color: "#aaa",
                        }}
                      >
                        {item.title}
                      </PretendardText>
                      <PretendardText
                        className="truncate"
                        style={{
                          width: "100%",
                          fontWeight: 500,
                          fontSize: 13,
                          lineHeight: "18.75px",
                          color: "rgba(181, 181, 181, 0.5)",
                        }}
                      >
                        {moment(item.updatedAt).format("YYYY-MM-DD HH:mm")}
                      </PretendardText>
                    </div>
                    <RedBtn
                      onClick={() => {
                        setDeleteStorageItemId(item.id);
                        setDeleteStorageItemModalOpen(true);
                      }}
                    >
                      삭제
                    </RedBtn>
                  </div>
                );
              })}
            </div>
          </Popup>
        </PopupOverLay>
      )}

      {/* 임시저장 삭제하기 모달 */}
      {deleteStorageItemModalOpen && (
        <Modal
          type="negative"
          title="삭제하시겠습니까?"
          text={
            <>
              삭제된 데이터는 복구가 불가합니다.
              <br />
              그래도 삭제하시겠습니까?
            </>
          }
          setModalOpen={setDeleteStorageItemModalOpen}
          onClick={handleDeleteStorageItem}
        />
      )}
    </>
  );
};

export default ShoppingProductCreateDetail;
